// client/src/features/quotations/lineEditChecks.ts
//
// What the quotation grid's Quantity and US$ cost cells refuse when a person types (B004).
// Owner answers, 2026-10-21: quantity 0 or blank is refused, a fractional count of a unit that
// counts things (2.5 CSE) is refused, and there is no maximum on quantity or cost.
// Passed to EditableCell's `validate`; a restated quantity (Unit dropdown) does not come here.
//
// B014 (owner answer, 2026-10-22): a TYPED negative markup is refused, in the Markup cell, the
// "Markup for all lines" bar and the Add Item form. The pricing owner's -99% floor is left as
// it is: it bounds what the arithmetic accepts, this is what a person may type.

import { isWholeCountQuantity } from '../../utils/unitConversionGraph';

const asNumber = (v: unknown): number | null => {
  if (typeof v === 'number') return Number.isFinite(v) ? v : null;
  if (v == null || String(v).trim() === '') return null;
  const n = Number(v);
  return Number.isFinite(n) ? n : null;
};

export const quantityEditProblem = (value: unknown, uom: unknown): string | null => {
  const qty = asNumber(value);
  if (qty == null) return 'Quantity is required';
  if (qty <= 0) return 'Quantity must be greater than 0';
  if (!isWholeCountQuantity(qty, uom)) {
    return `Quantity must be a whole number for ${String(uom || 'this unit').toUpperCase()}`;
  }
  return null;
};

export const unitCostEditProblem = (value: unknown): string | null => {
  const cost = asNumber(value);
  if (cost == null) return 'Cost is required';
  if (cost <= 0) return 'Cost must be greater than 0';
  return null;
};

/** Blank is not decided here: what a blank markup means is still an open question (B015). */
export const markupEditProblem = (value: unknown): string | null => {
  if (value == null || String(value).trim() === '') return null;
  const pct = Number(value);
  return pct < 0 ? 'Markup cannot be negative. Enter 0 or more.' : null;
};
